<template>
  <JanusRoomParticipantVideo :has-video="publisher.video"
                             :fixed="fixed === janusRoomMemberId" :name="name"
                             :is-speaking="isSpeaking"
  >
    <video v-show="publisher.video || publisher.share" ref="video" autoplay
           preload="metadata" muted playsinline
    />
    <audio v-show="false" ref="audio" :muted="muted" autoplay />
    <div class="participants__disable">
      <div v-show="!publisher.video && !publisher.share"
           class="participants__disable-item participants__disable-item_cam"
      />
      <div v-if="!publisher.audio"
           class="participants__disable-item participants__disable-item_mic"
      />
    </div>
  </JanusRoomParticipantVideo>
</template>

<script>
import useJanusListener from '@/compositions/useJanusListener';
import useVideo from '@/compositions/useVideo';
import JanusRoomParticipantVideo from '@/components/VideoRoomParticipantVideo.vue';
import useStreams from '@/compositions/useStreams';
import { ref, computed } from '@vue/composition-api';

export default {
  name: 'JanusRoomParticipant',
  components: { JanusRoomParticipantVideo },
  props: {
    janusRoomId: {
      type: Number,
      required: true,
    },
    janusRoomPrivateMemberId: {
      type: Number,
      required: true,
    },
    janusRoomMemberId: {
      type: Number,
      required: true,
    },
    isMyVideo: {
      type: Boolean,
    },
    name: {
      type: String,
      required: true,
    },
    publisher: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const {
      joinRoom, video, audio, connection,
    } = useJanusListener(props, context);
    const { muted } = useVideo();
    const { fixed, audioLevel } = useStreams();

    joinRoom();

    const isSpeaking = computed(() => {
      const level = audioLevel.value.find((l) => l.janusMemberId === props.janusRoomMemberId);
      return !!(level && level.volume > 0.01);
    });

    return {
      video,
      muted,
      fixed,
      audio,
      isSpeaking,
    };
  },
};
</script>

<style lang="scss" scoped>
.participants {
  display: flex;
  justify-content: right;
  align-items: flex-start;
  height: 7.5rem;
  padding: 0.625rem 0.625rem 0 8.125rem;
  &__item {
    min-width: 11.5rem;
    max-height: 6.75rem;
    border: 1px solid #2C2C2E;
    border-radius: 0.25rem;
    position: relative;
    background: url("../assets/img/icons/user.svg") no-repeat center;
    background-size: 20%;
    margin-left: 0.625rem;
    &.participants__item_my {
      border: 2px solid #2C2C2E;
    }
    &.participants__item_my video {
      transform: scale(-1, 1);
    }
  }
  &__disable {
    font-size: 0.5rem;
    color: #949494;
    position: absolute;
    bottom: 0;
    left: 0.375rem;
    right: 0.375rem;
    text-align: right;
  }
  &__disable-item {
    width: 1.375rem;
    height: 1.375rem;
    display: inline-block;
    background: rgba(0, 0, 0, 0.5) no-repeat;
    margin: 3px 1px;
    border-radius: 0.25rem;
    &_mic {
      background-image: url("../assets/img/icons/mic-off.svg");
      background-position: center 0.25rem;
    }
    &_cam {
      background-image: url("../assets/img/icons/cam-off.svg");
      background-position: 0.3125rem 0.375rem;
      background-size: 60%;
    }
  }
}
@media (max-width: 1199px) {
  .participants {
    height: auto;
    padding: 5.625rem 1.25rem 1.25rem;
    &__item {
      max-height: 7.75rem;
    }
  }
}
@media (max-width: 599px) {
  .participants {
    height: auto;
    padding: 5.625rem 1rem 1rem;
  }
}
</style>
